export default __webpack_public_path__ + "static/media/Binance-Icon-Logo.c6f56f81.svg";